/**
 * Created by lu on 2018/2/1.
 */
var nb = require('../../../nb');
var $ = nb.opts.$;
var util =require('../../../util');
module.exports = nb.define({
    parent:nb.model.List,
    method:{
        init:function () {
            this.setOpts({
                swiperId:'swiper-id-'+nb.getSeq(),
                itemType: require('../view/SeriesList').ProductItem
            });
            this.onChange('items',function (inEvent,inList) {
                $.each(inList, function (index, item) {
                    item.setOpts({
                        imgUrl:item.get('frontImg')+'?x-image-process=image/resize,m_pad,h_800,w_800,color_FFFFFF',
                        price: "￥" + util.numberFormat(item.get('price') / 100,0),
                        detailHref:"detail.html?id=" + item.get('id')
                    });
                });
            },this);


        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/ProductList.js
// module id = 174
// module chunks = 1 4